export {SectionState as default };

/**
* Section State
*
* Defines the state of a section during data fetch
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class SectionState {
  /**
   * Defines loading section ids
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {Object}
   */
  loading = {};

  /**
   * Defines loaded sections ids
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {Object}
   */
  loaded = {};

  /**
   * Stores loadded callback functions
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {Array}
   */
  loaded_callbacks = {};

  /**
   * Defines error ids
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {Object}
   */
  error = {};

  /**
   * Defines error callbacks functions
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {Object}
   */
  error_callbacks = {};

  /**
   * Sets the loading state to true
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {String} id  state id
   *
   * @return {void}
   */
  setLoading(id) {
    this.loading[id] = true;
    delete this.loaded[id];
    delete this.error[id];
  }

  /**
   * Sets the loaded state
   *
   * Calls all onload functions registered
   * if the load value is set to true
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {String}  id    state id
   * @param {Boolean} value loaded state
   * @param {Boolean} keep  true, keeps loaded entry, false discards loaded entry
   *
   * @return {void}
   */
  setLoaded(id, value, keep = true) {
    delete this.loading[id];

    if (value === false) {
      this.error[id] = true;
      return;
    }

    this.loaded[id] = true;
    this.callLoadedCallbacks(id);

    if (keep === false) {
      delete this.loaded[id];
    }
  }

  /**
   * Registers an on Loaded function to be called
   * When loaded finishes
   *
   * @public
   *
   * @param {String}   id       state id
   * @param {Function} callable
   *
   * @since 7.0.0
   *
   * @return {void}
   */
  onLoad(id, callable) {
    this.setLoadedCallback(id, callable);

    if (this.loaded[id]) {
      this.callLoadedCallbacks(id);
    }
  }

  /**
   * Sets a loadded callback function
   *
   * @private
   *
   * @since 7.0.0
   *
   * @param {String}   id        state id
   * @param {Function} callable
   *
   * @return {void}
   */
  setLoadedCallback(id, callback) {
    if (!this.loaded_callbacks[id]) {
      this.loaded_callbacks[id] = [];
    }

    this.loaded_callbacks[id].push(callback);
  }

  /**
   * Calls all registered loaded calbacks
   *
   * @private
   *
   * @since 7.0.0
   *
   * @param {String} id state id
   *
   * @return {void}
   */
  callLoadedCallbacks(id) {
    if (!this.loaded_callbacks[id]) {
      return;
    }

    this.loaded_callbacks[id].forEach((callback) => {
      callback();
    })

    delete this.loaded_callbacks[id];
  }
}